import { type RoleTypeEnum } from '../enums/RoleTypeEnum'

export interface UserSummaryRole {
  name: string
  type: RoleTypeEnum
}

export interface UserSummaryConstructor {
  id: number
  firstName: string
  lastName: string
  email: string
  profileImage: Nullable<string>
  role: Nullable<UserSummaryRole>
}

/**
 * The minimal user reference served by the `/users/{id}/basic/` and
 * `/users/basic/` endpoints: identity, contact and active role only. Not a
 * `User`, which carries categories, activity and tier this endpoint never
 * sends.
 */
export class UserSummary {
  readonly id: number
  readonly firstName: string
  readonly lastName: string
  readonly email: string
  readonly profileImage: Nullable<string>
  readonly role: Nullable<UserSummaryRole>

  constructor(data: UserSummaryConstructor) {
    this.id = data.id
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.email = data.email
    this.profileImage = data.profileImage
    this.role = data.role
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`
  }
}
